import {BaseModel} from '../../_base/crud';
import {Product} from './product';

export class ProductGroupModel extends BaseModel {
	id: number;
	name: string;
	description: string;
	status: number;

	_products: Product[];

	clear() {
		this.name = '';
		this.description = '';
		this.status = 0;
	}
}
